var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0013 0.666626C15.6346 0.666626 0.667969 15.6333 0.667969 34C0.667969 52.3666 15.6346 67.3333 34.0013 67.3333C52.368 67.3333 67.3346 52.3666 67.3346 34C67.3346 15.6333 52.368 0.666626 34.0013 0.666626ZM49.9346 26.3333L31.0346 45.2333C30.568 45.7 29.9346 45.9666 29.268 45.9666C28.6013 45.9666 27.968 45.7 27.5013 45.2333L18.068 35.8C17.1013 34.8333 17.1013 33.2333 18.068 32.2666C19.0346 31.3 20.6346 31.3 21.6013 32.2666L29.268 39.9333L46.4013 22.8C47.368 21.8333 48.968 21.8333 49.9346 22.8C50.9013 23.7666 50.9013 25.3333 49.9346 26.3333Z",
    fill: "#57AB69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.5ef8e522fe9bdb828aa1ca5618f61f9d.svg";
export { ForwardRef as ReactComponent };